import { Box } from "@chakra-ui/react";
import type { PropsWithChildren } from "react";

import { Footer } from "@/shared/layout/Footer";
import { Header } from "@/shared/layout/Header";

export function PageShell({ children }: PropsWithChildren) {
  return (
    <Box
      minH="100vh"
      bg="nvp.ink"
      color="white"
      overflowX="hidden"
      display="flex"
      flexDirection="column"
    >
      <Header />
      <Box flex="1" display="flex" flexDirection="column">
        {children}
      </Box>
      <Footer />
    </Box>
  );
}
